/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listClasses = /* GraphQL */ `
  query ListClasses(
    $filter: ModelClassFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClasses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        updatedAt
        startDate
        endDate
        startTime
        endTime
        name
        header
        summary
        description
        instructorId
        instructor {
          id
          firstName
          lastName
          title
          tagline
          bio
          gender
          image
          createdAt
          updatedAt
        }
        days
        price
        seats
        location
        category
        status
        image
        createdAt
      }
      nextToken
    }
  }
`;
export const listInstructors = /* GraphQL */ `
  query ListInstructors(
    $filter: ModelInstructorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInstructors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        title
        tagline
        bio
        gender
        image
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listUserClasses = /* GraphQL */ `
  query ListUserClasses(
    $userId: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelUserClassFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserClasses(
      userId: $userId
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        id
        classId
        firstName
        lastName
        email
        grade
        school
        findUs
        updates
        lunch
        paid
        payment
        createdAt
        updatedAt
        class {
          id
          updatedAt
          startDate
          endDate
          startTime
          endTime
          name
          header
          summary
          description
          instructorId
          instructor {
            id
            firstName
            lastName
            title
            bio
            tagline
            gender
            image
            createdAt
            updatedAt
          }
          days
          price
          seats
          location
          category
          status
          image
          createdAt
        }
      }
      nextToken
    }
  }
`;